module.exports = __webpack_public_path__ + "static/media/machinelearning.76a96f36.png";